import * as React from "react"
import { useRef } from "react"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { AutocompleteAsyncSeeker } from "@ui-seeker/core"

import { WEBBACK_V2_API } from "@constants"
import { brand, category, haveEncodedValue, sku, skuGroup } from "@signals"
import { DIPSkuInputAdornment } from '@components'



export default function CommonFiltersSku({ showAdornment=false, ...props}) {
	const typing = useRef(false)
	const skuOptions = useSignal([])
	const inputValue = useSignal("")
	const isLoading = useSignal(false)

	return <AutocompleteAsyncSeeker
		multiple
		urlAjax={`${WEBBACK_V2_API}/master-data/sku/find`}
		filters={{ brand: brand.value, category: category.value, skuGroup: skuGroup.value || '' }}
		label="SKUs"
		placeholder="Search SKU..."
		options={skuOptions.value}
		inputValue={inputValue.value}
		value={sku.value}
		formatOptionLabel={({ label, value }) => {
			if (value === "select_all")
				return <Box borderBottom="1px solid" width={1}>
					{label}
				</Box>
			return label
		}}
		limitTags={6}
		onChange={e => {
			if (props.multiple !== false && e.target.value.includes("select_all")) {
				sku.value = [...sku.value, ...skuOptions.value.filter(op => op.value !== "select_all")
					.filter(op => op.label.toLowerCase().includes(inputValue.value.toLowerCase()))
					.map(op => op.value)
				]
			} else {
				sku.value = e.target.value
			}
			inputValue.value = ""
		}}
		onInitAjax={() => isLoading.value = true}
		onFinishAjax={options => {
			isLoading.value = false
			skuOptions.value = [
				...props.multiple !== false ? [{label: "Select All", value: "select_all"}] : [],
				...options
			]

			if (skuGroup.value && !typing.current)
				if(!haveEncodedValue.value){
					sku.value = options.map(({value}) => value)
				}
				haveEncodedValue.value = false
		}}
		onInputChange={(_, newInputValue, reason) => {
			if (reason !== "clear")
				typing.current = true
			inputValue.value = newInputValue
		}}
		inputProps={showAdornment ? {
			endAdornment: <DIPSkuInputAdornment skuOptions={skuOptions} isLoading={isLoading.value} />
		} : undefined}
		{...props}
	/>
}